const PlumberIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="plumber"
  >
    <title>a-icons / 32px / services / plumber</title>
    <g id="a-icons-/-32px-/-services-/-plumber" fill="none" fillRule="evenodd">
      <g fill={color || '#00008F'} fillRule="nonzero">
        <g>
          <g>
            <path
              d="M26.07 11.2c0-.26-.21-.47-.47-.47H12.518V6.366c0-.26-.211-.47-.47-.47H9.128V4.328h2.113c.26 0 .47-.21.47-.47V.94h9.37c.26 0 .47-.21.47-.47S21.343 0 21.083 0H1.558c-.26 0-.47.21-.47.47-.005.035-.005.07 0 .104-.053 3.445-.048 3.459.16 3.638.085.075.195.117.31.117H3.67v1.567H.753c-.26 0-.47.211-.47.471V31.53c0 .26.21.471.47.471h11.294c.26 0 .47-.21.47-.47V15.623h8.095v2.037c0 .26.21.47.47.47h2.353v.975c0 .26.211.47.47.47.26 0 .471-.21.471-.47v-.974H25.6c.26 0 .47-.21.47-.47V11.2zM2.048.941h8.725v2.447h-8.74c-.004-.564 0-1.572.015-2.447zM4.612 4.33h3.576v1.567H4.612V4.33zm6.964 26.73H1.224V6.838h10.352v24.22zm.942-19.388h12.611v3.011H12.522c.024-1.548.033-2.447.014-3.011h-.018zm12.611 5.52h-3.576v-1.567h3.576v1.567z"
              transform="translate(-245 -233) translate(245 233) translate(3)"
            />
            <path
              d="M23.906 20.33c-.26 0-.47.21-.47.47v1.13c0 .26.21.47.47.47s.47-.21.47-.47V20.8c0-.26-.21-.47-.47-.47zM23.906 23.153c-.26 0-.47.21-.47.47v1.13c0 .26.21.47.47.47s.47-.21.47-.47v-1.13c0-.26-.21-.47-.47-.47zM23.906 25.976c-.26 0-.47.211-.47.471v1.13c0 .26.21.47.47.47s.47-.21.47-.47v-1.13c0-.26-.21-.47-.47-.47z"
              transform="translate(-245 -233) translate(245 233) translate(3)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PlumberIcon;
